module.exports = __webpack_public_path__ + "img/logo.5bfbbdc2.png";